import React from "react";
import styled, { css } from "styled-components";
import { ResourceList } from "./ResourceList";
import {
    Visibility as VisibilityIcon,
    Edit as EditIcon,
} from "@material-ui/icons";
import { Button } from "@material-ui/core";
import { push } from "connected-react-router";
import { useDispatch } from "react-redux";
import moment from "moment";
const StyledButton = styled(Button)`
    && {
        max-height: 30px;
        min-height: 0px !important;
        max-width: 30px;
        min-width: 0px !important;
        width: 30px;
        height: 30px;
        padding: 0px !important;
        padding-left: 0px !important;
        pointer-events: all;
    }
`;
interface IDayProps {
    day: number;
    track: string;
    jobpacks: any[];
}

interface IDayContainer {
    day: number;
}

interface IEventFace {
    colour: string;
    selected: boolean;
    count: number;
}

const EventFace = styled.div<IEventFace>`
    pointer-events: none;
    background-color: rgba(
        ${(props) => props.colour},
        ${(props) => (props.selected ? 0.74 : 0.2)}
    );
    border: 2px solid ${(props) => (props.selected ? "blue" : "black")};
    border-radius: 8px;
    display: grid;
    grid-template-rows: 30px 1fr;
    grid-template-columns: 1fr;
    height: ${(props) => 100 / props.count}%;
    overflow: hidden;
`;

const EventInfo = styled.div`
    grid-row: 4;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-auto-rows: min-content;
`;

interface IJobStyle {
    rowIndex: number;
}

const JobStyle = css<IJobStyle>`
    padding: 5px;
    font-size: 0.8em;
    grid-row: ${(props) => props.rowIndex};
`;

const JobTitle = styled.div`
    ${JobStyle}
    grid-column: 1;
    font-weight: bold;
`;
const JobPersonnel = styled.div`
    ${JobStyle}
    grid-column: 2;
`;

const DayContainer = styled.div<IDayContainer>`
    grid-row: 1;
    grid-column: ${(props) => props.day + 1};
    width: 100%;
    height: 100%;
    overflow: hidden;
`;

interface IEventHeader {
    selected: boolean;
}

const EventHeader = styled.div<IEventHeader>`
    pointer-events: none;
    grid-row: 1;
    grid-column: 1;
    z-index: 3;
    width: 100%;
    height: 100%;
    background-color: rgba(
        0,
        0,
        0,
        ${(props) => (props.selected ? 0.84 : 0.2)}
    );
    color: ${(props) => (props.selected ? "white" : "black")};
    display: grid;
    font-size: 1em;
    padding-left: 5px;
    overflow: hidden;
    display: grid;
    grid-template-columns: 1fr 30px 30px;
    grid-template-rows: 1fr;
`;

const HeaderText = styled.div`
    grid-row: 1;
    grid-column: 1;
    overflow: hidden;
`;

interface IHeaderLink {
    column: number;
}
const HeaderLink = styled.div<IHeaderLink>`
    grid-row: 1;
    grid-column: ${(props) => props.column};
`;

const PersonnelRow = ({ jobTitle, jobPersonnel, rowIndex }: any) => {
    return (
        <>
            <JobTitle rowIndex={rowIndex}>{jobTitle}</JobTitle>
            <JobPersonnel rowIndex={rowIndex}>{jobPersonnel}</JobPersonnel>
        </>
    );
};

export const Day = (props: IDayProps) => {
    const dispatch = useDispatch();
    const getDayInfo = (jobpack: any) => {
        const {
            assigned_manager,
            assigned_operatives,
            assigned_supervisor,
            job_name,
            job_id,
            client_name,
        } = jobpack.profile;
        let timestamp = jobpack.profile.timestamp.split(" ");
        let year = timestamp[0].toString();
        let finalYear = moment(year, "DD-MM-YYYY").format("YYYY");
        let finalMonth = moment(year, "DD-MM-YYYY").format("MMM").toLowerCase();

        const managerRowStart = 3;
        const supervisorRowStart = Array.isArray(assigned_manager)
            ? assigned_manager.length + managerRowStart
            : managerRowStart + 1;
        const operativesRowStart = Array.isArray(assigned_supervisor)
            ? assigned_supervisor.length + supervisorRowStart
            : supervisorRowStart + 1;

        const selected = false;
        return (
            <EventFace
                count={props.jobpacks.length}
                colour={jobpack.colour}
                selected={selected}
            >
                <EventHeader selected={selected}>
                    <HeaderText>{job_id}</HeaderText>
                    <HeaderLink column={2}>
                        <StyledButton
                            color="inherit"
                            onClick={() => {
                                dispatch(
                                    push(
                                        `/job-pack-view/jobpacks/active/${finalYear}/${finalMonth}/${jobpack.profile.job_id}`
                                    )
                                );
                            }}
                        >
                            <VisibilityIcon color="inherit" />
                        </StyledButton>
                    </HeaderLink>
                    <HeaderLink column={3}>
                        <StyledButton
                            color="inherit"
                            onClick={() => {
                                dispatch(
                                    push(
                                        `/job-pack-edit/jobpacks/active/${finalYear}/${finalMonth}/${jobpack.profile.job_id}`
                                    )
                                );
                            }}
                        >
                            <EditIcon color="inherit" />
                        </StyledButton>
                    </HeaderLink>
                </EventHeader>
                <EventInfo>
                    <PersonnelRow
                        jobTitle={`Job Number`}
                        jobPersonnel={job_name}
                        rowIndex={1}
                    />
                    <PersonnelRow
                        jobTitle={`Client`}
                        jobPersonnel={client_name}
                        rowIndex={2}
                    />
                    {(Array.isArray(assigned_manager) &&
                        assigned_manager.map((e, i) => {
                            return (
                                <PersonnelRow
                                    jobTitle={`Manager ${i + 1}`}
                                    jobPersonnel={e.user_name}
                                    rowIndex={managerRowStart + i}
                                    key={i}
                                />
                            );
                        })) || (
                        <PersonnelRow
                            jobTitle={"Manager"}
                            jobPersonnel={assigned_manager}
                            rowIndex={managerRowStart}
                        />
                    )}

                    <PersonnelRow
                        jobTitle={"Supervisor"}
                        jobPersonnel={
                            assigned_supervisor
                                ? assigned_supervisor.user_name
                                : typeof assigned_supervisor === "string"
                                ? assigned_supervisor
                                : "N/A"
                        }
                        rowIndex={supervisorRowStart}
                    />

                    {Array.isArray(assigned_operatives) &&
                        assigned_operatives.map((e, i) => {
                            return (
                                <PersonnelRow
                                    jobTitle={`Operative ${i + 1}`}
                                    jobPersonnel={e.user_name}
                                    rowIndex={operativesRowStart + i}
                                    key={i}
                                />
                            );
                        })}
                </EventInfo>
            </EventFace>
        );
    };

    return (
        <DayContainer day={props.day}>
            {Array.isArray(props.jobpacks) &&
                props.jobpacks.map((jobpack, i) => {
                    return (
                        <React.Fragment key={i}>
                            {getDayInfo(jobpack)}
                        </React.Fragment>
                    );
                })}

            <ResourceList day={props.day} track={props.track} />
        </DayContainer>
    );
};
